module.exports = __webpack_public_path__ + "img/Expand.c648cde9.svg";